export default __webpack_public_path__ + "535d57139ff9c1d133335a4561114e80.png";